import { Box, Heading } from '@weareberyl/design-system'
import { useEffect, useState } from 'react'

import { auth } from '~/utils/firebase'
import Copy from '../Copy'

const Token = () => {
  const [token, setToken] = useState<string | null>(null)

  useEffect(() => {
    const getToken = async () => {
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken(true)
        setToken(token)
      }
    }

    getToken()
  }, [])

  return (
    <>
      <Box mb={3}>
        <Heading variant="h1">
          Authentication Token
          <span> – {auth.currentUser?.email}</span>
        </Heading>
      </Box>
      <Copy id="token" text={token ?? ''} nowrap />
    </>
  )
}

export default Token
